import { gql } from '@apollo/client'

const UPDATED_METADATA_SUBSCRIPTION = gql`
  subscription onUpdateIngredient {
    metadataUpdated {
      ingredients
      dishTypes
      allergens
      diets
      updatedByUserId
    }
  }
`

export default UPDATED_METADATA_SUBSCRIPTION
